import { Injectable } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';

@Injectable({
  providedIn: 'root'
})
export class DbInitService {

  constructor(private dbService: NgxIndexedDBService) { }

  init() {
    // No need to open database manually; module config handles it
    // console.log('IndexedDB is ready via NgxIndexedDBModule config');
  }

  // Optional: clear a store
  clearStore(storeName: string) {
    return this.dbService.clear(storeName);
  }
}
